import { render, staticRenderFns } from "./TenantStandardWindow.vue?vue&type=template&id=2731b620&scoped=true&"
import script from "./TenantStandardWindow.vue?vue&type=script&lang=js&"
export * from "./TenantStandardWindow.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../../../Users/qiancheng/Documents/Workspace/cargoware/cargoware-h5-haichuang/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2731b620",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/qiancheng/Documents/Workspace/cargoware/cargoware-h5-haichuang/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2731b620')) {
      api.createRecord('2731b620', component.options)
    } else {
      api.reload('2731b620', component.options)
    }
    module.hot.accept("./TenantStandardWindow.vue?vue&type=template&id=2731b620&scoped=true&", function () {
      api.rerender('2731b620', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/cargo/v0/SystemMaintenance/components/sysMenu/TenantStandardWindow.vue"
export default component.exports